import { useMemo } from 'react'

import { Field } from 'types'

export default function useMetricCategories(
    metricsColumns: Field<any>[],
    categoryOrder?: string[]
): (string | undefined)[] | undefined {
    const metricCategories = useMemo(() => {
        const uniqueCategories = Array.from(
            new Set(metricsColumns.map((m) => m.metricOptions?.category))
        )
        if (uniqueCategories.length > 1) {
            if (categoryOrder) {
                return uniqueCategories.sort(
                    (a, b) =>
                        categoryOrder.indexOf(a ?? '') -
                        categoryOrder.indexOf(b ?? '')
                )
            }
            return uniqueCategories
        }
        return undefined
    }, [metricsColumns, categoryOrder])
    return metricCategories
}
